import { CheckoutState } from '../../state';
import { getEnablePaymentConstraintsInNewCreate } from '../app';
import {
    getIsFreeEvent,
    getIsReservedSeating,
    hasSpecialInstructions,
    isWaitlistEnabled,
} from '../event';

export const areSyncExpressCheckoutEligibleCommonRulesMet = (
    state: CheckoutState,
) =>
    !getEnablePaymentConstraintsInNewCreate(state) &&
    !getIsFreeEvent(state) &&
    !getIsReservedSeating(state) &&
    !hasSpecialInstructions(state) &&
    !isWaitlistEnabled(state);
